import React from 'react';
import Navbar from './components/Navbar';
import './App.css';
import Home from './components/pages/Home';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Discord from './components/pages/Discord';
import Redstone from "./components/pages/Redstone";

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Switch>
          <Route path='/' exact component={Home} />
          <Route path='/discord' component={Discord} />
            <Route path='/Redstone' component={Redstone}/>
        </Switch>
      </Router>
    </>
  );
}

export default App;
